import {IFileIdAndOwner, IFileToPathConverter} from '../../interfaces/ifiletopathconverter';

export class InveniasFileToPathConverter implements IFileToPathConverter {
  private readonly listType: string;

  constructor(listType: string) {
    this.listType = listType;
  }

  convert(file: IFileIdAndOwner): string[] {
    return [
      file.belongsTo?.type, // people
      file.belongsTo?.id, // people id
      this.listType,
      file.id, // document id
    ];
  }
}
